export const NEW_PACKET_NAME = 'New Packet (Unsaved)';
export const NEW_PACKET_ID = 'new';
